import React from 'react';
import { alert, Alert, Button } from 'equasion-lib';
import './ErrorBoundary.scss';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    // console.log('this.props', this.props);
    // Display fallback UI
    this.setState({ hasError: true, errorMessage: error.message });
    // todo: Log to error logging service instead of console.
    // logErrorToService(error, info);

    // eslint-disable-next-line
    console.log('ERROR: ', error);
    // eslint-disable-next-line
    console.log('ERROR INFO: ', info);

    alert('Error', error.message.substring(0, 50), 4, 'error');
  }

  render() {
    const { children } = this.props;
    const { hasError, errorMessage } = this.state;

    if (!children || hasError) {
      return (
        <div className="error-page-wrap">
          <h1>Oops!</h1>
          <p>
            We experienced a critical error. Please report this to an administrator.
            Refresh the page.
          </p>
          <Button onClick={() => document.location.reload()}>Refresh Page</Button>
          <h4>Error message:</h4>
          <Alert message={errorMessage} />
        </div>
      );
    }
    return children;
  }
}
